import { createContext, useContext } from "react";

export type Lang = "en" | "ar" | "fr";

export const LANG_STORAGE_KEY = "lms-lang";

export type Dict = { en: string; ar?: string; fr?: string };

export const t = (lang: Lang, d: Dict): string => d[lang] ?? d.en;

// Per-session YouTube video IDs by language. English is the fallback.
// Keyed by session number (1–8, == episode number).
export const SESSION_VIDEOS: Record<number, Dict> = {
  1: { en: "NDFvjaQM6FA", ar: "l56kgvFO0-g", fr: "pOrWyMVwMxw" }, // Money Choices
  2: { en: "KS8YHTWHHqs", ar: "hdt_OqT22Wo", fr: "txp1yb9SeuQ" }, // The 3 Statements
  3: { en: "Rv8qkj6AG8E", ar: "zQ8VLVNshTU", fr: "Qifs7dA-dHw" }, // Plan Your Money
  4: { en: "o74YO6R-2CE", ar: "0LvSrTcxjAs", fr: "6-Z7ms7VETs" }, // How Taxes Work
  5: { en: "yDNkenH7Kuc", ar: "dRobc1oznS8", fr: "jU1v52Ow2r0" }, // Funding Choices
  6: { en: "WZF2RPcjrXU", ar: "sZkw5IzZ8fk", fr: "s8C3kQD0YGk" }, // The Cost of Credit
  7: { en: "LGViXLQ_0cM", ar: "cD_zQs3hljQ", fr: "Z6h4QnKBRwY" }, // Risk and Growth
  8: { en: "LmHkyym6wII", ar: "61ITaEpiqZE", fr: "8UoR6m7gu_8" }, // Digital Finance
};

export const sessionVideoId = (sessionNumber: number, lang: Lang): string =>
  SESSION_VIDEOS[sessionNumber]?.[lang] ?? SESSION_VIDEOS[sessionNumber]?.en ?? "";

export function langSrc(src: string, lang: Lang): string {
  if (lang === "en") return src;
  // session-scoped visuals: /visuals/s6/x.png -> /visuals/s6/ar/x.png
  if (/^\/visuals\/s\d+\//.test(src)) {
    return src.replace(/^\/visuals\/(s\d+)\//, `/visuals/$1/${lang}/`);
  }
  // shared top-level visuals: /visuals/activity.png -> /visuals/ar/activity.png
  return src.replace(/^\/visuals\/([^/]+)$/, `/visuals/${lang}/$1`);
}

export const LangContext = createContext<Lang>("en");
export const useLang = (): Lang => useContext(LangContext);
